module.exports = __webpack_public_path__ + "img/color_seekbar_thum.b310d5f7.png";